<footer role="contentinfo" class="cg-hide-for-print">
  <div class="upper-footer">
    <div class="footer-inner-wrapper">
      <div class="container-fluid cg-margin-bottom-md cg-margin-top-md">
        <div class="row">
          <div class="col-sm-3">
            <h4 class="cg-h4 cg-margin-bottom-none">Site tour</h4>
            <div class="cg-margin-bottom-sm">(4 minute video)</div>
            <div class="cg-margin-bottom-md">
              <div>
                <button
                  cignaButton="link"
                  style="padding: 0"
                  (click)="openSiteTourModal()"
                  data-test="footer-sitetour-link"
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Quick website overview',
                    'ac-NV008-Footer Links',
                    {
                      prop20: 'footer-main-links'
                    }
                  ]"
                >
                  Quick website overview
                </button>
              </div>
            </div>
            <h4 class="cg-h4 cg-margin-bottom-none cg-margin-top-lg">
              Education and training tutorials
            </h4>
            <div class="cg-margin-bottom-sm">
              (videos approx. 5 minutes each)
            </div>
            <div class="cg-margin-bottom-md">
              <div
                class="cg-margin-bottom-xs"
                *ngIf="!loggedIn || (loggedIn && isMedical)"
              >
                <a
                  target="resourcesWindow"
                  [href]="
                    '/resourceLibrary/eCourses/eCoursesMedicalListing'
                      | resourceLink: { secure: loggedIn }
                      | async
                  "
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Medical',
                    'ac-NV012-Education Links',
                    { prop20: 'footer-education-links' }
                  ]"
                  >Medical</a
                >
              </div>
              <div class="cg-margin-bottom-xs">
                <a
                  target="resourcesWindow"
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Dental',
                    'ac-NV012-Education Links',
                    { prop20: 'footer-education-links' }
                  ]"
                  [href]="
                    '/resourceLibrary/eCourses/eCoursesDentalListing'
                      | resourceLink: { secure: loggedIn }
                      | async
                  "
                  >Dental</a
                >
              </div>
              <div
                class="cg-margin-bottom-xs"
                *ngIf="!loggedIn || (loggedIn && isMedical)"
              >
                <a
                  target="resourcesWindow"
                  [href]="
                    '/resourceLibrary/eCourses/eCourseBehavioralListing'
                      | resourceLink: { secure: loggedIn }
                      | async
                  "
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Behavioral',
                    'ac-NV012-Education Links',
                    { prop20: 'footer-education-links' }
                  ]"
                  >Behavioral</a
                >
              </div>
              <div></div>
            </div>

            <h4 class="cg-h4 cg-margin-bottom-sm cg-margin-top-lg">
              Website access manager resources
            </h4>

            <div class="cg-margin-bottom-md">
              <div class="cg-margin-bottom-xs">
                <a
                  target="resourcesWindow"
                  [href]="
                    '/resourceLibrary/websiteAccessManager/websiteAccessManagers'
                      | resourceLink: { secure: loggedIn }
                      | async
                  "
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Resources page and webinars',
                    'ac-NV013-Wam Links',
                    { prop20: 'footer-wam-resources-links' }
                  ]"
                  >Resources page & webinars</a
                >
              </div>
              <div class="cg-margin-bottom-xs">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  [href]="
                    '/pdf/resourceLibrary/eCourses/website-access-managers-ecourse.pdf'
                      | resourceLink: { secure: false, type: 'file' }
                      | async
                  "
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'Tutorial',
                    'ac-NV013-Wam Links',
                    { prop20: 'footer-wam-resources-links' }
                  ]"
                  >Tutorial</a
                >
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="cg-h4 cg-margin-bottom-md">Other Cigna websites</h4>
            <div class="cg-margin-bottom-md">
              <div>Medicare Providers</div>
              <div>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://medicareproviders.cigna.com"
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'https://medicareproviders.cigna.com',
                    'ac-NV008-Footer Links'
                  ]"
                  >https://medicareproviders.cigna.com<cigna-icon
                    type="external-link"
                    class="cg-mat-icon-link-right cg-color-digital-blue"
                  ></cigna-icon>
                </a>
              </div>
            </div>
            <div class="cg-margin-bottom-md">
              <div>Cigna Global Health Benefits</div>
              <div>
                <a
                  target="_blank"
                  rel="noopener"
                  href="https://provider.cignaenvoy.com"
                  [cignaTrackClicks]="[
                    'trackEventOther',
                    'https://provider.cignaenvoy.com',
                    'ac-NV008-Footer Links'
                  ]"
                  >https://provider.cignaenvoy.com<cigna-icon
                    type="external-link"
                    class="cg-mat-icon-link-right cg-color-digital-blue"
                  ></cigna-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div>
              <h4 class="cg-h4 cg-margin-bottom-md">Follow us</h4>
              <div class="social-links">
                <a
                  href="http://www.twitter.com/cigna"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-twitter"
                  aria-label="twitter"
                  [cignaTrackClicks]="[
                    'trackEventExit',
                    'Twitter.com',
                    'ac-NV009-Social Media',
                    {
                      prop20: 'footer-social-profile-links'
                    }
                  ]"
                >
                  <cigna-icon
                    type="twitter-square"
                    class="social-icon"
                  ></cigna-icon>
                </a>

                <a
                  href="http://www.linkedin.com/companies/cigna"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-linkedin"
                  aria-label="linkedin"
                  [cignaTrackClicks]="[
                    'trackEventExit',
                    'Linkedin.com',
                    'ac-NV009-Social Media',
                    {
                      prop20: 'footer-social-profile-links'
                    }
                  ]"
                >
                  <cigna-icon
                    type="linkedin-square"
                    class="social-icon"
                  ></cigna-icon>
                </a>
                <a
                  href="http://www.facebook.com/cigna"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-facebook"
                  aria-label="facebook"
                  [cignaTrackClicks]="[
                    'trackEventExit',
                    'Facebook.com',
                    'ac-NV009-Social Media',
                    {
                      prop20: 'footer-social-profile-links'
                    }
                  ]"
                >
                  <cigna-icon
                    type="facebook-square"
                    class="social-icon"
                  ></cigna-icon>
                </a>
                <a
                  href="http://www.youtube.com/cigna"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="social-youtube"
                  aria-label="youtube"
                  [cignaTrackClicks]="[
                    'trackEventExit',
                    'YouTube.com',
                    'ac-NV009-Social Media',
                    {
                      prop20: 'footer-social-profile-links'
                    }
                  ]"
                >
                  <cigna-icon
                    type="youtube-play-square"
                    class="social-icon"
                  ></cigna-icon>
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="flex-row">
              <a
                href="http://www.cigna.com/health-careprofessionals/health-care-reform"
                class="cg-margin-right-xl"
                style="margin-left: auto"
                target="_blank"
                rel="noopener noreferrer"
                [cignaTrackClicks]="[
                  'trackEventOther',
                  'Informed on Reform',
                  'ac-NV011-Icons',
                  { prop20: 'footer-icon-links' }
                ]"
              >
                <img
                  [src]="'assets/images/footer/informed.png' | cdnPrefix"
                  alt="informed on reform"
                  title="informed on reform"
                />
              </a>
              <a
                href="https://www.caqh.org/core"
                class="cg-margin-right-xl"
                target="_blank"
                rel="noopener noreferrer"
                [cignaTrackClicks]="[
                  'trackEventExit',
                  'Core',
                  'ac-NV011-Icons',
                  { prop20: 'footer-icon-links' }
                ]"
              >
                <img
                  [src]="'assets/images/footer/core1.png' | cdnPrefix"
                  alt="CAQH-CORE"
                  title="CAQH-CORE"
                  width="53"
                />
              </a>
              <div class="cg-text-center flex-column">
                <a
                  href="https://www.websecurity.symantec.com/ssl-certificate"
                  title="Norton Security"
                  target="_blank"
                  rel="noopener noreferrer"
                  [cignaTrackClicks]="[
                    'trackEventExit',
                    'Norton Secured',
                    'ac-NV011-Icons',
                    { prop20: 'footer-icon-links' }
                  ]"
                >
                  <img
                    [src]="'assets/images/footer/norton.png' | cdnPrefix"
                    alt="Norton Secure"
                    title="Norton Security"
                  />
                </a>

                <a
                  href="https://www.websecurity.symantec.com/ssl-certificate"
                  class="cg-margin-top-sm"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="font-size: 12px"
                  [cignaTrackClicks]="[
                    'trackEventExit',
                    'About SSL Certificates',
                    'ac-NV011-Icons',
                    { prop20: 'footer-icon-links' }
                  ]"
                >
                  About SSL Certificates<cigna-icon
                    type="external-link"
                    class="cg-mat-icon-link-right cg-color-digital-blue"
                  ></cigna-icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lower-footer">
      <div class="footer-inner-wrapper">
        <div class="cg-margin-bottom-lg">
          &copy; {{ currentYear }} Cigna. All rights reserved.
        </div>
        <div>
          <button
            style="padding: 0"
            cignaButton="link"
            class="lower-footer__link"
            (click)="openSiteHelpModal()"
            data-test="footer-help-link"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Need help?',
              'ac-NV010-Legal Links',
              { prop20: 'footer-legal-links' }
            ]"
          >
            Need help?
          </button>

          <button
            style="padding: 0"
            cignaButton="link"
            class="lower-footer__link"
            (click)="openLegalDisclaimerModal()"
            data-test="footer-legal-link"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Legal disclaimer',
              'ac-NV010-Legal Links',
              { prop20: 'footer-legal-links' }
            ]"
          >
            Legal disclaimer
          </button>
          <button
            style="padding: 0"
            cignaButton="link"
            class="lower-footer__link"
            (click)="openPrivacyModal()"
            data-test="footer-privacy-link"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Privacy',
              'ac-NV010-Legal Links',
              { prop20: 'footer-legal-links' }
            ]"
          >
            Privacy
          </button>
          <a
            class="lower-footer__link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/web-nondiscrimination-notice.pdf"
            [cignaTrackClicks]="[
              'trackEventDownload',
              'Nondiscrimination notice',
              'ac-NV010-Legal Links',
              { prop20: 'footer-legal-links' }
            ]"
            >Nondiscrimination notice</a
          >
        </div>
        <div class="footer-disclaimer">
          <cigna-icon
            type="external-link"
            class="cg-mat-icon-link-left cg-color-white"
          ></cigna-icon>
          Selecting these links will take you away from CignaforHCP.com. Cigna
          does not control the linked sites' content or links.
          <a
            class="lower-footer__link"
            href="http://www.cigna.com/legal-disclaimer#d_legal"
            target="_blank"
            rel="noopener noreferrer"
            >Details</a
          >
        </div>
      </div>
    </div>
  </div>
</footer>
